module.exports = __webpack_public_path__ + "img/zignuts-logo.206632be.png";